import { SecurityPage } from '@pages/security/security.page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/security')({
  component: SecurityPage,
})
